import { render, staticRenderFns } from "./GraduationCertificates.vue?vue&type=template&id=fa575938&scoped=true"
import script from "./GraduationCertificates.vue?vue&type=script&lang=js"
export * from "./GraduationCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa575938",
  null
  
)

export default component.exports